import { render, staticRenderFns } from "./CollectionFilterControlTypeText.vue?vue&type=template&id=721736dc"
import script from "./CollectionFilterControlTypeText.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionFilterControlTypeText.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports